import angular from "angular";

angular
    .module('app')
    .component('textAngularTableInsert', {
        template: require('./text-angular-table-insert.html'),
        controller: ['$http', '$scope', controller],
        bindings: {
            close: '&',
        }
    });

function controller($http, $scope, $uibModal) {

    let $ctrl = this;

    $ctrl.rows = null;
    $ctrl.cols = null;

    $ctrl.$onInit = function () {
    };

    $ctrl.makeTable = function () {
        $ctrl.table = new Array($ctrl.rows);
        for (var i = 0; i < $ctrl.rows; i++) {
            $ctrl.table[i] = new Array($ctrl.cols);
            for (var j = 0; j < $ctrl.cols; j++) {
                $ctrl.table[i][j] = {
                    text: "",
                }
            }
        }
    }

    $ctrl.insert = function () {
        var resTable = "<table>"
        for (var i = 0; i < $ctrl.table.length; i++) {
            resTable += "<tr>"
            for (var j = 0; j < $ctrl.table[i].length; j++) {
                resTable += "<td>" + $ctrl.table[i][j].text + "</td>";
            }
            resTable += "</tr>";
        }
        resTable += "</table><br>";

        $ctrl.close({
            $value: {
                table: resTable,
            }
        });
    }

}